import { IconButton } from "@material-ui/core";
import { useMemo } from "react";
import { Column, useTable } from "react-table";
import { Badge, Link } from "@funcional/react-ui";
import { IntlDateTime, IntlMoney } from "@funcional/react-intl-ui";
import { ITransaction } from "@pbm/transactions/contracts";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { ReactTable } from "@funcional/react-table-ui";

interface TransactionsListProps {
  data: ITransaction[];
  filters: any;
  setFilters: any;
}

interface CellProps {
  value: any;
  row: { original: ITransaction };
}

const translateTransactionStatus = (type: string): string => {
  return (
    {
      AUTHORIZED: "autorizada",
      UNAUTHORIZED: "não autorizada",
      CANCELED: "cancelada",
    }[type] || type.toLowerCase()
  );
};

const translateTransactionStatusColor = (
  type: string
): "success" | "danger" | "warning" | "default" => {
  return ({
    AUTHORIZED: "success",
    UNAUTHORIZED: "danger",
    CANCELED: "warning",
  }[type] || "default") as "success" | "danger" | "warning" | "default";
};

export function TransactionsList({
  data,
  filters,
  setFilters,
}: TransactionsListProps) {
  const columns: Column<ITransaction>[] = useMemo(
    () =>
      [
        {
          Header: "ID",
          accessor: "id",
          Cell: ({ value, row: { original } }: CellProps) => (
            <Link to={`/pbm/transactions/${original.id}`}>{value}</Link>
          ),
        },
        {
          Header: "№ Aut.",
          accessor: "legacyIdentifiers.authorizationId",
          title: "Número da Autorização",
        },
        {
          Header: "№ Seq.",
          accessor: "legacyIdentifiers.sequenceId",
          title: "Número Sequencial",
        },
        { Header: "CNPJ", accessor: "storeCode" },
        {
          Header: "Status",
          accessor: "status",
          Cell: ({ value }) => (
            <Badge color={translateTransactionStatusColor(value)}>
              {translateTransactionStatus(value)}
            </Badge>
          ),
        },
        {
          Header: "Data",
          accessor: "createdAt",
          Cell: ({ value }) => <IntlDateTime value={value} />,
        },
        {
          Header: "R$",
          accessor: "netValue",
          Cell: ({ value }) => <IntlMoney value={value} />,
        },
        {
          id: "crud",
          Cell: ({ row }: any) => (
            <div className="flex gap-x-4">
              <IconButton
                title="Ver registro"
                href={`/pbm/transactions/${row.original.id}`}
              >
                <VisibilityIcon />
              </IconButton>
            </div>
          ),
        },
      ] as Column<ITransaction>[],
    []
  );

  const tableInstance = useTable({
    columns,
    data,
  } as any);

  return <ReactTable tableInstance={tableInstance} />;
}
